// extracted by mini-css-extract-plugin
export const promoWrapper = "promo-module-top-module--promo-wrapper--16VWL";
export const promoTop = "promo-module-top-module--promo-top--1qFOl";
export const headline = "promo-module-top-module--headline--3IcKy";
export const body = "promo-module-top-module--body--2pa5w";
export const content = "promo-module-top-module--content--2OAS7";
export const image = "promo-module-top-module--image--tA3Gb";